export const isAdmin = () => !!localStorage.getItem('admin-token');
export const getToken = () => localStorage.getItem('admin-token');
